import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import Survey from "@/pages/trove/Survey";
import Circle from "@/pages/trove/Circle";
import KM from "@/pages/trove/KM";
import DM from "@/pages/trove/DM";
import MeetingCalednar from "@/pages/trove/MeetingCalendar";


const TroveRouter = [
  {
    path: "dm",
    element: (
      <SuspenseWrapper>
        <DM />
      </SuspenseWrapper>
    ),
  },
  {
    path: "survey",
    element: (
      <SuspenseWrapper>
        <Survey />
      </SuspenseWrapper>
    ),
  },
  {
    path: "circle",
    element: (
      <SuspenseWrapper>
        <Circle />
      </SuspenseWrapper>
    ),
  },
  {
    path: "meetingCalendar",
    element: (
      <SuspenseWrapper>
        <MeetingCalednar />
      </SuspenseWrapper>
    ),
  },
  {
    path: "km",
    element: (
      <SuspenseWrapper>
        <KM />
      </SuspenseWrapper>
    ),
  },
  
];

export default TroveRouter;
